module.exports = __webpack_public_path__ + "static/media/hdi-parking-selected.f216a32d.svg";